import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.jpg'

import ornament from './img/ornament.png'

import wave from './img/wave.png'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  locale = 'pt-BR',
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale)
    .format(new Date(weddingDate.timestamp))
    .replaceAll('/', ' - ')

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro352">
      <input
        type="hidden"
        id="anPageName"
        name="page"
        value="animated-intro-large-all-breakpoints"
      />
      <div className="animated-intro-small screen">
        <img
          className="background-4QFuFN"
          src={background || backgroundImg}
          alt="Background"
        />
        <div
          className="site-de-casamento-e-4QFuFN"
          dangerouslySetInnerHTML={{ __html: warningMessage }}
        />
        <div className="button-4QFuFN smart-layers-pointers">
          <div className="pular-introduo-YrZHDo" onClick={onSkipIntro}>
            {buttonMessage}
          </div>
        </div>
        <img
          className="ornament-4QFuFN bp1-animate-enter"
          src={ornament}
          alt="Ornament"
        />
        <div className="date-4QFuFN bp1-animate-enter1">
          <div className="x08-06-2024-5o1Uum sm---title-sm">{date}</div>
        </div>
        <div className="couple-name-4QFuFN bp1-animate-enter2">
          <div className="m-e-DINxli">
            {coupleSimplifiedName.bride}
            {coupleSimplifiedName.groom && ` + ${coupleSimplifiedName.groom}`}
          </div>
        </div>
        <img
          className="wave-1-4QFuFN bp1-animate-enter3"
          src={wave}
          alt="wave 1"
        />
      </div>
      <div className="animated-intro-large-all-breakpoints screen">
        <img
          className="background-mJEZdQ"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-mJEZdQ">
          <div
            className="site-de-casamento-e-Ifj7wC"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-Ifj7wC smart-layers-pointers">
            <div className="pular-introduo-cSB8CC" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-mJEZdQ bp2-animate-enter">
          <div className="m-e-c06wRT">
            {coupleSimplifiedName.bride}
            {coupleSimplifiedName.groom && ` + ${coupleSimplifiedName.groom}`}
          </div>
        </div>
        <img
          className="wave-1-mJEZdQ bp2-animate-enter1"
          src={wave}
          alt="wave 1"
        />
        <div className="date-mJEZdQ bp2-animate-enter2">
          <div className="x08-06-2024-SCajat lg---title-sm">{date}</div>
        </div>
        <img
          className="ornament-mJEZdQ bp2-animate-enter3"
          src={ornament}
          alt="Ornament"
        />
      </div>{' '}
    </CheckImagesLoaded>
  )
}

export default Intro
